// Path: src/components/workshoppage/ScaleContainer.tsx
import React, { useRef, useState, useEffect } from 'react';

export const ScaleContainer = ({ children }: { children: React.ReactNode }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  const TARGET_WIDTH = 1920; 
  const TARGET_HEIGHT = 1080;

  useEffect(() => {
    const handleResize = () => {
      if (!containerRef.current?.parentElement) return;
      const parent = containerRef.current.parentElement;
      const availableWidth = parent.clientWidth - 40; 
      const availableHeight = parent.clientHeight - 40;
      setScale(Math.min(availableWidth / TARGET_WIDTH, availableHeight / TARGET_HEIGHT));
    };

    window.addEventListener('resize', handleResize);
    handleResize(); 
    
    const observer = new ResizeObserver(handleResize);
    if (containerRef.current?.parentElement) observer.observe(containerRef.current.parentElement);

    return () => {
      window.removeEventListener('resize', handleResize);
      observer.disconnect();
    };
  }, []);

  return (
    <div ref={containerRef} className="flex items-center justify-center">
      <div 
        style={{
          width: `${TARGET_WIDTH}px`, height: `${TARGET_HEIGHT}px`,
          transform: `scale(${scale})`, transformOrigin: 'center center',
          transition: 'transform 0.1s ease-out'
        }}
        className="shadow-2xl bg-white"
      >
        {children}
      </div>
    </div>
  );
};
